import { render, staticRenderFns } from "./DecentralizationManager.vue?vue&type=template&id=582e8b9e&scoped=true&"
import script from "./DecentralizationManager.vue?vue&type=script&lang=js&"
export * from "./DecentralizationManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582e8b9e",
  null
  
)

export default component.exports